import actionTypes from '../../actions/actionTypes'
import { fromJS } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT, META_MOVIE_ORIGIN_KEYS } from '../../constants/state'


const INIT_STATE = fromJS(PROGRAM_DEFAULT.metaMovies)



const updateOrigin = (state, action) => {
    const { pk, dataMeta } = action.payload 
    let item = state.getIn(['items', action.payload.pk])

    META_MOVIE_ORIGIN_KEYS.map(key => {
        item = item.set(key, dataMeta[key])
    })

    return state.setIn(['items', pk], item)
}


const metaMoviesReducer = (state = INIT_STATE, action) => {

    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.METAMOVIES_UPDATE_ITEM_ORIGIN:
            return updateOrigin(state, action)
        case actionTypes.TMDB_MATCH_SUCCESS: {
            const metaMovie = action.payload.metaMovie
            if (!metaMovie || !metaMovie.pk) return state
            let item = state.getIn(['items', metaMovie.pk]) || fromJS({})
            META_MOVIE_ORIGIN_KEYS.forEach(key => {
                if (metaMovie[key] !== undefined) {
                    item = item.set(key, metaMovie[key])
                }
            })
            return state.setIn(['items', metaMovie.pk], item)
        }
        default:
            return state;
    }
}

export default metaMoviesReducer